import { useEffect, useState } from 'react';
import type { AiCallDialogue, AiCallVo } from '@/facilities/modules/aiCall';
import { toMillis } from './utils';

export const isLive = (call: AiCallVo | null | undefined) =>
  call?.status === 'IN_PROGRESS';

/** Ticks once a second while `active`; returns the elapsed time since `since` as mm:ss. */
export const useElapsed = (
  since: AiCallDialogue['timestamp'] | null | undefined,
  active = true,
) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return undefined;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [active]);
  const start = toMillis(since);
  if (!start) return '00:00';
  const total = Math.max(0, Math.floor((now - start) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};
